export const GET_CASHBOOK_PARTY_HEADS = "GET_CASHBOOK_PARTY_HEADS"
export const GET_CASHBOOK_PARTY_HEADS_SUCCESS = "GET_CASHBOOK_PARTY_HEADS_SUCCESS"

export const SAVE_CASHBOOK_PARTY_HEAD = "SAVE_CASHBOOK_PARTY_HEAD"
export const SAVE_CASHBOOK_PARTY_HEAD_SUCCESS = "SAVE_CASHBOOK_PARTY_HEAD_SUCCESS"

export const CASHBOOK_ENTRY_API_ERROR_ACTION = "CASHBOOK_ENTRY_API_ERROR_ACTION"

export const GET_CASHBOOK_ENTRY_LIST = "GET_CASHBOOK_ENTRY_LIST"
export const GET_CASHBOOK_ENTRY_LIST_SUCCESS = "GET_CASHBOOK_ENTRY_LIST_SUCCESS"

export const EDIT_CASHBOOK_ENTRY_ID = "EDIT_CASHBOOK_ENTRY_ID"
export const EDIT_CASHBOOK_ENTRY_ID_SUCCESS = "EDIT_CASHBOOK_ENTRY_ID_SUCCESS"

export const UPDATE_CASHBOOK_ENTRY_ID = "UPDATE_CASHBOOK_ENTRY_ID"
export const UPDATE_CASHBOOK_ENTRY_ID_SUCCESS = "UPDATE_CASHBOOK_ENTRY_ID_SUCCESS"

export const DELETE_CASHBOOK_ENTRY_ID = "DELETE_CASHBOOK_ENTRY_ID";
export const DELETE_CASHBOOK_ENTRY_ID_SUCCESS = "DELETE_CASHBOOK_ENTRY_ID_SUCCESS";